import select from './select'

const reject = (obj, cb) => {
  return select(obj, (...args) => cb(...args) == false)
}

export default reject
